import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "35",
  height: "12",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#172B85",
      "fill-rule": "evenodd",
      d: "M8.75 11.314H5.721L3.45 2.468c-.108-.407-.337-.767-.674-.936A9.721 9.721 0 0 0 0 .596v-.34h4.88A1.28 1.28 0 0 1 6.142 1.36l1.179 6.38L10.348.256h2.945L8.75 11.315Zm6.227 0h-2.86L14.471.255h2.86l-2.355 11.06Zm6.056-7.995c.085-.596.59-.936 1.179-.936a5.236 5.236 0 0 1 2.776.51l.506-2.381A7.112 7.112 0 0 0 22.885 0c-2.776 0-4.797 1.532-4.797 3.658 0 1.617 1.432 2.466 2.442 2.978 1.093.51 1.514.85 1.43 1.36 0 .766-.842 1.107-1.683 1.107-1.01 0-2.02-.255-2.945-.682l-.505 2.383c1.01.425 2.103.596 3.113.596 3.114.084 5.048-1.447 5.048-3.744 0-2.892-3.955-3.062-3.955-4.337ZM35 11.314 32.729.255h-2.44c-.505 0-1.01.34-1.179.85l-4.206 10.21h2.945l.588-1.617h3.618l.337 1.616H35Zm-4.29-8.08.84 4.167h-2.355l1.515-4.168Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "visa"}) } }